"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaystePublicPricingQuery = exports.PricingZoneQuery = exports.PricingZoneUpdate = exports.PricingZoneCreate = exports.PricingZone = exports.ServiceAreaCreate = exports.ServiceArea = exports.PricingGrowthStage = exports.PricingGrowthStages = exports.PricingZoneDailyAvailability = exports.ZoneType = exports.ZoneTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const ca_state_1 = require("./ca-state");
const fee_1 = require("./fee");
const roll_off_material_price_matrix_1 = require("./roll-off-material-price-matrix");
const sales_tax_1 = require("./sales-tax");
const service_area_envelope_1 = require("./service-area-envelope");
const us_state_1 = require("./us-state");
// export enum ZoneType {
//   SOURGUM_INTERNAL = 'SOURGUM_INTERNAL', // only in sourgum -- in wayste was SOURGUM
//   HAULER_BILLING = 'HAULER_BILLING', // only in sourgum -- in wayste was GENERAL
//   PUBLIC = 'PUBLIC', // only in sourgum
// }
exports.ZoneTypes = ['SOURGUM_INTERNAL', 'HAULER_BILLING', 'PUBLIC'];
exports.ZoneType = typebox_1.Type.Union(exports.ZoneTypes.map((type) => typebox_1.Type.Literal(type)));
exports.PricingZoneDailyAvailability = typebox_1.Type.Union([
    typebox_1.Type.Literal('OPEN'),
    typebox_1.Type.Literal('CLOSED'),
    typebox_1.Type.Literal('LIMITED'),
    typebox_1.Type.Literal('UNKNOWN'),
]);
exports.PricingGrowthStages = ['SEED', 'GROWTH', 'MATURE'];
exports.PricingGrowthStage = typebox_1.Type.Union(exports.PricingGrowthStages.map((stage) => typebox_1.Type.Literal(stage)));
exports.ServiceArea = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    serviceArea: service_area_envelope_1.ServiceAreaEnvelope, // SG was called boundary
    areaName: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxJurisdiction: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
exports.ServiceAreaCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.ServiceArea, ['id', 'metadata', 'serviceArea']),
    typebox_1.Type.Object({
        serviceArea: typebox_1.Type.String(),
        serviceAreaFormat: typebox_1.Type.Union([typebox_1.Type.Literal('KML'), typebox_1.Type.Literal('GEOJSON')]),
    }),
]);
exports.PricingZone = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    serviceAreas: typebox_1.Type.Array(exports.ServiceArea),
    haulerID: typebox_1.Type.String({ format: 'uuid' }), // made required in sg
    haulerName: typebox_1.Type.String(), // made required in sg
    materials: typebox_1.Type.Array(roll_off_material_price_matrix_1.RollOffMaterialPriceMatrix), // Renamed from pricingData. wayste has PricingMaterial instead of MaterialPricingTransport -- SG called this pricingData
    prohibitedItems: typebox_1.Type.Array(typebox_1.Type.String()),
    state: typebox_1.Type.Union([us_state_1.UsStateAbbreviation, ca_state_1.CAProvinceAbbreviation]),
    tripCharge: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    active: typebox_1.Type.Boolean(),
    days: typebox_1.Type.Object({
        mon: exports.PricingZoneDailyAvailability,
        tue: exports.PricingZoneDailyAvailability,
        wed: exports.PricingZoneDailyAvailability,
        thu: exports.PricingZoneDailyAvailability,
        fri: exports.PricingZoneDailyAvailability,
        sat: exports.PricingZoneDailyAvailability,
        sun: exports.PricingZoneDailyAvailability,
    }),
    rentalPeriod: typebox_1.Type.Optional(common_1.Duration),
    rentExtensionFee: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    zoneName: typebox_1.Type.Optional(typebox_1.Type.String()),
    pricingCalculationVersion: typebox_1.Type.Optional(typebox_1.Type.String()),
    maxRentalDaysAllowed: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    prePaidRentalDaysDiscountRate: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    allowForPrePaidRentalDays: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    haulerApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    sourgumApproved: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    type: exports.ZoneType,
    actualTaxRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    // Only in SG not in Wayste
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    onlineCheckoutPageGuarantee: typebox_1.Type.Optional(typebox_1.Type.String()),
    currentGrowthStage: typebox_1.Type.Optional(exports.PricingGrowthStage),
    metro: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxRateBreakdown: typebox_1.Type.Optional(sales_tax_1.TaxRateBreakDown),
    // From wayste new to SG
    fees: typebox_1.Type.Array(fee_1.PricingFee),
    taxRateOverride: typebox_1.Type.Optional(typebox_1.Type.Number()),
    linkedZoneID: typebox_1.Type.Optional(typebox_1.Type.String()),
    // deleting now
    // customerDiscounts in wayste, which appears to be only used for online checkout pricing tiers
    //  rentExtensionFeeDollars: Type.Optional(Nullable(Type.Number())),
    // tripChargeDollars: Type.Optional(Nullable(Type.Number())),
    // onlineCheckoutTiers: Type.Optional(Type.Array(Type.Any())), // was only in wayste and never used anywhere
    // public: Type.Boolean(),
    // linkedZone: Type.Optional(PricingZone),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.PricingZoneCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.PricingZone, [
        'id',
        'metadata',
        'serviceAreas',
        'actualTaxRate',
        'taxRateBreakdown',
        'materials',
        'fees',
        'active',
        'sourgumApproved',
        'haulerApproved',
    ]),
    typebox_1.Type.Object({
        haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    }),
]);
exports.PricingZoneUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.PricingZone, [
        'id',
        'haulerID',
        'metadata',
        'serviceAreas',
        'materials',
        'fees',
        'actualTaxRate',
        'taxRateBreakdown',
        'type',
        'tripCharge',
        'rentExtensionFee',
        'notes',
        'metro',
        'taxRateOverride',
        'active',
        'sourgumApproved',
        'haulerApproved',
    ]),
    typebox_1.Type.Object({
        tripCharge: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Integer())),
        rentExtensionFee: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Integer())),
        notes: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
        metro: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String())),
        taxRateOverride: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Null(), typebox_1.Type.Number()])), // Nullable() doesn't work here - it'll coerce a null value to 0, which we don't want
    }),
]));
exports.PricingZoneQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.PricingZone, ['haulerID', 'state', 'type', 'active', 'customerID']),
    typebox_1.Type.Object({
        includeExpiredMaterials: typebox_1.Type.Boolean(),
        includeExpiredFees: typebox_1.Type.Boolean(),
        limit: typebox_1.Type.Integer(),
        offset: typebox_1.Type.Integer(),
        lat: typebox_1.Type.Number(),
        lng: typebox_1.Type.Number(),
    }),
]));
exports.WaystePublicPricingQuery = typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.PricingZone, ['haulerID']),
    typebox_1.Type.Pick(exports.PricingZoneQuery, ['lat', 'lng']),
    typebox_1.Type.Object({
        zip: typebox_1.Type.String(),
        country: typebox_1.Type.String(),
    }),
]);
//# sourceMappingURL=pricing-zone.js.map